import baseUrl from "../config/baseUrl";

const markDocumentAsFavourite = async ({ token, ids }) => {
  const formData = new FormData();
  formData.append("ids", ids);
  try {
    const response = await fetch(
      `${baseUrl}/api/favourtite-bulk-all?ids=${ids}`,
      {
        method: "PUT",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default markDocumentAsFavourite;
